var map = {
	"./aebischer.jpg": 798,
	"./badertscher.jpg": 801,
	"./baumann.jpg": 516,
	"./bertschy.jpg": 450,
	"./buehler.jpg": 491,
	"./funiciello.jpg": 428,
	"./gafner.jpg": 977,
	"./grossen.jpg": 817,
	"./guggisberg.jpg": 872,
	"./hess.jpg": 903,
	"./hess2.jpg": 469,
	"./imboden.jpg": 462,
	"./jost.jpg": 988,
	"./masshardt.jpg": 823,
	"./mettler.jpg": 909,
	"./pieren.jpg": 869,
	"./siegenthaler.jpg": 327,
	"./trede.jpg": 920,
	"./wasserfallen.jpg": 281,
	"./wasserfallen2.jpg": 167
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 960;